import React from 'react';
import { useFormContext } from '../../../context/FormContext';
import { Input } from '../../ui/Input';

export const AnnualSpendSection = () => {
  const { data, updateFormSection } = useFormContext();
  const spend = data.form.annualSpend;

  const updateField = (year, field, value) => {
    updateFormSection('annualSpend', spend.map(s => s.year === year ? { ...s, [field]: value } : s));
  };

  // Determine current currency from transaction 0 (default to GBP)
  const currencySymbol = data.form.transactions[0]?.currency === 'EUR' ? '€' : '£';

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {spend.map((s) => (
        <div key={s.year} className="flex flex-col sm:flex-row items-start sm:items-center gap-4 p-4 border border-brand-border rounded-xl bg-brand-light/10">
          <div className="w-16 font-serif font-bold text-brand-accent text-lg">{s.year}</div>
          <div className="flex-1 w-full space-y-3">
            <Input 
              placeholder={`Annual spend (${currencySymbol})`}
              type="number" 
              value={s.spend} 
              onChange={e => updateField(s.year, 'spend', e.target.value)} 
            />
            <Input 
              placeholder="Product / Service Category" 
              value={s.category} 
              onChange={e => updateField(s.year, 'category', e.target.value)} 
            />
          </div>
        </div>
      ))}
    </div>
  );
};